<script setup lang="ts">
  import { useField } from 'vee-validate';
  import type { CheckboxProps } from '~/models/form-field';
  import { computed } from 'vue';

  const { name, checkedValue, checked: initialChecked, rules, description, inputLayout } = defineProps<CheckboxProps>();

  const { errorMessage, handleChange, checked, meta } = useField(name, rules, {
    type: 'radio',
    checkedValue: checkedValue as any,
    initialValue: initialChecked ? (checkedValue as any) : undefined
  });

  const isRequired = computed(() => typeof rules === 'string' && rules.includes('required'));
</script>

<template>
  <div
    :data-input-layout="inputLayout"
    :class="[
      'form-radio',
      {
        'form-radio--error': !!errorMessage,
        'form-radio--success': meta.valid
      }
    ]">
    <label class="form-radio__wrapper">
      <span class="form-radio__input-group">
        <span class="form-radio__input-wrapper">
          <input
            tabindex="0"
            type="radio"
            :name="name"
            :value="checkedValue"
            :checked="checked"
            class="form-radio__input"
            formnovalidate
            @input="handleChange(checkedValue)" />
          <span class="form-radio__icon" />
        </span>
        <span class="form-radio__label">
          <slot :is-required="isRequired">
            {{ label }}
            <span v-if="isRequired">*</span>
          </slot>
        </span>
      </span>
      <span v-if="description" class="form-radio__description">{{ description }}</span>
    </label>
    <div
      v-if="errorMessage"
      class="form-radio__error">
      <span />
      <span>{{ errorMessage }}</span>
    </div>
  </div>
</template>
